// @flow

import { type BrazilianDocumentType } from './types';

export function getDocumentTypeFromFormattedValue(value: ?string): BrazilianDocumentType {
  return !value || value.length <= 14 ? 'cpf' : 'cnpj';
}

export function getDocumentTypeFromRawValue(value: ?string): BrazilianDocumentType {
  return !value || value.length <= 11 ? 'cpf' : 'cnpj';
}

export function getDocumentTypeInferredFromValue(value: ?string): BrazilianDocumentType {
  return !value || /^[0-9]+$/.test(value)
    ? getDocumentTypeFromRawValue(value)
    : getDocumentTypeFromFormattedValue(value);
}
